import axios from 'axios';
import {API_URL} from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

const URL = `${API_URL}/register/`;

/**
 * @param {UserFirstName} firstName
 * @param {UserLastName} lastName
 * @param {UserEmail} email
 * @param {UserPassword} password
 * @param {UserStudio} studio
 */

const registerUser = async (firstName: string, lastName: string, email: string, password: string, studio: string) => {
  const res = await axios.post(URL, {
    'firstName': firstName,
    'lastName': lastName,
    'email': email,
    'password': password,
    'studio': studio,
  });
  return res.data;
};

const actions = {
  registerUser,
};

export default actions;
